import { render } from "./UnitComponent.vue?vue&type=template&id=dcb73102"
import script from "./UnitComponent.vue?vue&type=script&lang=js"
export * from "./UnitComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Unit/UnitComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dcb73102"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dcb73102', __exports__)) {
    api.reload('dcb73102', __exports__)
  }
  
  module.hot.accept("./UnitComponent.vue?vue&type=template&id=dcb73102", () => {
    api.rerender('dcb73102', render)
  })

}


export default __exports__